import React from 'react'
import Label from "components/general/Label";
import SportCode from "components/common/SportCode";
import { ColumnStartOrder, ColumnBib, ColumnPty, ColumnRank, ColumnRankNoType, ColumnName, ColumnNoc, ColumnResult, ColumnQualification, ColumnExpander } from "components/common/TableColumns"

function ColumnBibColour() {
  return (
      {
          Header: <Label data="HeaderBib" />,
          accessor: 'startSortOrder',
          className: 'text-end',
          headerClassName: 'text-end w-5',
          disableSortBy: true,
          id: 'Bib',
          Cell: (props) => {
              var colour = ''
              switch(props.cell.row.original?.startOrder){
                case 'b':
                  colour = 'bg-blue';
                  break;
                case 'g': 
                  colour = 'bg-green';
                  break;
                case 'r':
                  colour = 'bg-red';
                  break;
                case 'y':
                  colour = 'bg-yellow';
                  break;
              }

              return (
                  <div className={`w-100 px-1 ${colour}`}>
                      {props.cell.row.original?.bib}
                  </div>
              )
          }
      }
  )
}

function ColumnQualificationFault() {
  return(
    {
      accessor: 'qualificationMark',
      className: 'text-end fw-bold',
      headerClassName: 'text-end w-5',
      disableSortBy: true,
      id: 'QualMark',
      Cell: (props) => {
        let item = props.cell.row.original
        return (
          <>
          {item?.resultType === 'IRM' 
              ? <SportCode discipline="CSL" code={item?.resultIrm} entity="@IRM" abbr={true}/>
              : (item?.resultType === 'FAULT' && item?.resultIrm === 'RAL')                
                ? <SportCode discipline="CSL" code={item?.resultIrm} entity="@IRM" abbr={true}/>
                : item?.resultData 
          }
          {item?.qualificationMark &&
            <span className='ps-1'><SportCode discipline="CSL" code={item?.qualificationMark} entity="	@QualificationMark" abbr={true}/></span>
          }
          </>
        )
      }
    }  
  )
}


export function TableColumnsQUALStartList() {
  return (
      [
        ColumnStartOrder({}),
        ColumnBib({}),
        ColumnNoc({}),
        ColumnName({}),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsQUALStartListSM() {
  return (
      [
        ColumnBib({ disableSort: true, accesor: 'startSortOrder' }),
        ColumnNoc({ disableSort: true }),
        ColumnName({ disableSort: true }),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsQUALLive() {
  return (
      [
          ColumnRankNoType({}),
          ColumnStartOrder({}),
          ColumnBib({}),
          ColumnNoc({}),
          ColumnName({}),
          ColumnResult({ disableSort: true, label: "HeaderTime"}),
          ColumnPty({label: ""}),
          ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsQUALLiveSM() {
  return (
      [
        ColumnRankNoType({ disableSort: true }),
        ColumnBib({ disableSort: true }),
        ColumnNoc({ disableSort: true }),
        ColumnName({ disableSort: true }),
        ColumnResult({ disableSort: true, label: "HeaderTime" }),
        ColumnPty({label: ""}),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsQUALFinish() {
  return (
      [
        ColumnRankNoType({}),
        ColumnNoc({}),
        ColumnName({}),
        ColumnResult({ disableSort: true, label: "HeaderTime" }),
        ColumnPty({label: ""}),
        ColumnQualification({ className: "text-end fw-bold" }),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsQUALFinishSM() {
  return (
      [
        ColumnRankNoType({ disableSort: true }),
        ColumnNoc({ disableSort: true }),
        ColumnName({ disableSort: true }),
        ColumnResult({ disableSort: true, label: "HeaderTime" }),
        ColumnPty({label: ""}),
        ColumnQualification({ className: "text-end fw-bold" }),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsELIMStartList() {
  return (
      [
        ColumnBibColour(),
        ColumnNoc({ disableSort: true }),
        ColumnName({ disableSort: true }),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsELIMLive() {
  return (
      [
        ColumnRank({ disableSort: true }),
        ColumnBib({ disableSort: true }),
        ColumnNoc({ disableSort: true }),
        ColumnName({ disableSort: true }),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsELIMFinish() {
  return (
      [
        ColumnRank({ disableSort: true }),
        ColumnNoc({ disableSort: true }),
        ColumnName({ disableSort: true }),
        ColumnQualificationFault(),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}